import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { selectcommunitySubscriptionsListItems } from "../../../../../../redux/community-subscriptions/selector";
import { communitySubscriptions } from "../../../../../../redux/community-subscriptions/action";
import { selectListItems } from "../../../../../../redux/library/selector";


const Subscriptions = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
   const libraryData = useSelector(selectListItems)

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

    const subscriptionsItems = useSelector(selectcommunitySubscriptionsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          
          { field: 'CommunityName', headerName: 'Community Name', searchField: 'CommunityName', filter: true,
            filterType: 'text' },
             { field: 'Email', headerName: 'E-mail' },
              { field: 'PhoneNumber', headerName: 'Phone Number'},
            { field: 'CommunityUserStatusId', headerName: 'Community UserStatus', cellRenderer: 'libraryRendererComponent',
              cellRendererParams: { library: libraryData?.result?.ApprovalStatus },},
            { field: 'IsActive', headerName: 'Is Active', cellRenderer: 'yesNoRenderer' },
 

        ]);
      }


      const handleSearch = (data: any) => {
      
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "CommunityId",
            FieldText: "CommunityId",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(communitySubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/list`,entity:'subscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
    
   

      const handleReloadData = () => {
        dispatch(communitySubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/list`,entity:'subscriptions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchCommunitySubscriptions=()=>{
        dispatch(communitySubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/list`,entity:'subscriptions',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const additionButtons: any = [
      
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        
        callback: () => handleReloadData(),
        },
      ];
	useEffect(() => {
        createColumnDefs()
        fetchCommunitySubscriptions()
	}, [pageData,pageSize])
  const handleDelete=(data: any)=>{
    dispatch(communitySubscriptions.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/delete`,
      entity: 'subscriptions',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(communitySubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/list`,entity:'subscriptions',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
	return (
    <>
    {subscriptionsItems?.isLoading ?  <PageLoader />: 
		<Table   enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={subscriptionsItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={subscriptionsItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="Community Subscriptions"/>
     
  }
  </> 
	);
};

export default Subscriptions;